/**
 * Helper functions for CreateDriverPageV2
 * Pure functions that don't depend on React hooks or component state
 */

/**
 * Create driver payload from driver data
 * @param {Object} driver - Driver data object
 * @returns {Object} Formatted payload for API
 */
export const createDriverPayload = (driver) => ({
	vendor_id: driver.vendor_id,
	vehicle_type_ids: driver.vehicle_type_ids,
	driver_name: driver.driver_name,
	mobile_number: driver.mobile_number,
	document_info: {
		driving_license: {
			document_key: driver.driving_license_file,
			valid_till: driver.driving_license_valid_till,
			number: driver.driving_license_number || '',
		},
		aadhar: {
			document_key: driver.aadhar_file || '',
			number: driver.aadhar_number,
		},
	},
});

/**
 * Format error message based on error type
 * @param {string} errorMessage - Error message from API
 * @param {Object} driver - Driver data object
 * @returns {string} Formatted error message
 */
export const formatErrorMessage = (errorMessage, driver) => {
	if (errorMessage.includes('City Code does not exist')) {
		return `${driver.driver_name}: The selected Vendor (${driver.vendor_name}) or Vehicle Type (${driver.vehicle_type_name}) is missing required city code configuration. Please contact the administrator to configure city codes for these entities.`;
	}
	return `${driver.driver_name}: ${errorMessage}`;
};
